export default __webpack_public_path__ + "images/JCB.ea5749437fd777b744fb679f89045cd2.svg";